import { render, staticRenderFns } from "./TalkingIdol.vue?vue&type=template&id=427242b2&scoped=true"
import script from "./TalkingIdol.vue?vue&type=script&lang=js"
export * from "./TalkingIdol.vue?vue&type=script&lang=js"
import style0 from "./TalkingIdol.vue?vue&type=style&index=0&id=427242b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427242b2",
  null
  
)

export default component.exports